// src/components/common/HeroSection.tsx

import React from "react";
import { HeroSectionData } from "../../types/interfaces";
import "../../styles/HeroSection.css";

interface HeroSectionProps extends HeroSectionData {
  id: string;
  ctaLink?: string;
  requestServiceName?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  ctaText,
  ctaLink,
  image,
  id,
  requestServiceName,
  secondaryCtaText,
  secondaryCtaLink,
}) => {
  const getRequestAwareLink = (href: string) => {
    if (href !== "/contact" || !requestServiceName) {
      return href;
    }

    return `/contact?service=${encodeURIComponent(
      requestServiceName
    )}&source=solution-hero`;
  };

  const handleButtonClick = () => {
    const linkUrl = ctaLink ? getRequestAwareLink(ctaLink) : undefined;

    if (!linkUrl) {
      return;
    }

    const isExternalLink = /^https?:\/\//i.test(linkUrl);
    if (isExternalLink) {
      window.open(linkUrl, "_blank", "noopener,noreferrer");
      return;
    }

    const isRouteLink = linkUrl.startsWith("/");
    const isSameRouteHash = linkUrl.startsWith(`${window.location.pathname}#`);
    if (isRouteLink && !isSameRouteHash) {
      window.location.assign(linkUrl);
      return;
    }

    const hashIndex = linkUrl.indexOf("#");
    const targetId = hashIndex !== -1 ? linkUrl.slice(hashIndex + 1) : linkUrl;

    setTimeout(() => {
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      } else {
        console.warn(`Element with id ${targetId} not found.`);
      }
    }, 0);
  };
  
  return (
    <section className="hero" id={id}>
      <div className="hero-content">
        <h1 className="hero-title">{title}</h1>
        <p className="hero-subtitle">{subtitle}</p>
        <div className="hero-actions">
          <button className="hero-cta" onClick={handleButtonClick}>
            {ctaText}<span aria-hidden="true"> ↗</span>
          </button>
          {secondaryCtaText && secondaryCtaLink && (
            <a className="hero-secondary" href={secondaryCtaLink}>
              {secondaryCtaText}
            </a>
          )}
        </div>
      </div>
      <div className="hero-image-wrapper">
        <img className="hero-image" src={image} alt="" />
      </div>
    </section>
  );
};

export default HeroSection;
